import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import PageLayout from '../layout';

import { useStore } from '../store';
import CourseOverview from './components/courseOverview';

import './course.less';
import './course.mobile.less';
import './general-staff-a/general.less';
import './general-staff-a/general-moblie.less';
import './general-staff-a/general.theme.less';
import './senior-manager/senior-manager.en.less';
import './finance/finance.en.less';
import './finance/finance.less';
import './finance/finance-moblie.less';
import './HR/hr.en.less';
import './HR/hr.less';
import './HR/hr-moblie.less';
import './market/market.en.less';
import './market/market.less';
import './market/market-moblie.less';
import './customer/customer.en.less';
import './customer/customer.less';
import './customer/customer-moblie.less';
import './it/it.en.less';
import './it/it.less';
import './it/it-moblie.less';
import './ngo/ngo.en.less';
import './ngo/ngo.less';
import './ngo/ngo-moblie.less';
import './E-commerce/E-commerce.en.less';
import './E-commerce/E-commerce.less';
import './E-commerce/E-commerce-moblie.less';
import './startup/startup.en.less';
import './startup/startup.less';
import './startup/startup-moblie.less';
import './fsi/fsi.en.less';
import './fsi/fsi.less';
import './fsi/fsi-moblie.less';
import './student/student.en.less';
import './student/student.less';
import './student/student-moblie.less';
import './general2024/general2024.en.less';
import './general2024/general2024.less';
import './general2024/general2024-moblie.less';

import NextTopicIcon from './../../../assets/next-icon.svg';
import { Button } from 'antd';
import Paragraphs from './components/paragraphs';
import MenuFoldOutlined from '@ant-design/icons/lib/icons/MenuFoldOutlined';
import MenuUnfoldOutlined from '@ant-design/icons/lib/icons/MenuUnfoldOutlined';
import MenuOutlined from '@ant-design/icons/lib/icons/MenuOutlined';
import { GeneralStaff } from './general-staff-a';
import { SeniorManager } from './senior-manager';
import { Finance } from './finance';
import { HR } from './HR';
import { Market } from './market';
import { Customer } from './customer';
import { IT } from './it';
import { NGO } from './ngo';
import { ECommerce } from './E-commerce';
import { Startup } from './startup';
import { FSI } from './fsi';
import { Student } from './student';
import { General2024 } from './general2024';

interface ICourseProps {}
const Course: React.FunctionComponent<ICourseProps> = (props) => {
  const param = useParams();
  const navigate = useNavigate();
  const [sideCollapsed, setSideCollapsed] = React.useState(
    window.innerWidth <= 1024 ? true : false
  );
  const p_course = param.course;
  const p_topic = param['*'] || 'welcome';
  const {
    initPageSettings,
    getCourseState,
    setCourseState,
    courses,
    page,
    language,
  } = useStore();
  initPageSettings();

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 1024) {
        setSideCollapsed(true);
      }
    }

    window.addEventListener('resize', handleResize);
    window.addEventListener('click', (e: any) => {
      if (
        window.innerWidth < 1024 &&
        ((e.path &&
          !e?.path?.some(
            (itm: any) =>
              itm.className?.indexOf &&
              itm.className?.indexOf('course-left-side') !== -1
          )) ||
          (!(
            e.target?.parentElement?.className
              ?.toString()
              .indexOf('toggle-menu-icon') !== -1 ||
            e.target?.parentElement?.parentElement?.className
              ?.toString()
              .indexOf('toggle-menu-icon') !== -1
          ) &&
            ![
              'ant-progress-text',
              'course-name',
              'step-dot',
              'course-left-side',
              'course-left-overview',
              'ant-progress-circle-path',
              'ant-progress-circle-trail',
            ].some((itm: any) => e.target.classList.contains(itm)) &&
            !['paragraph'].some((itm: any) =>
              e.target.parentElement.classList.contains(itm)
            )))
      ) {
        setSideCollapsed(true);
      }
    });
  });
  if (!page || !courses || !p_course) {
    return <div>Loading</div>;
  }
  const courseState = getCourseState(p_course);
  const course = courses[p_course];
  const { title: courseTitle, steps, nextLabel, topics } = course;
  const currentTopic = topics.find((itm: { id: string }) => itm.id === p_topic);
  const progress = courseState.progress;
  const currentStep = courseState.step;
  const nextTopic = topics.find(
    (itm: { id: string }) => itm.id === currentTopic.next
  );
  const currentTopicStates = courseState.topicStates.find(
    (t) => t.id === p_topic
  );
  const currentParagraphState = currentTopicStates?.paragraphStates;
  const paragraphs = (currentTopic.paragraphs || []).map((p: any) => ({
    ...p,
    state: currentParagraphState?.find((ps) => ps.id === p.id)?.state,
  }));
  const gotoNextTopic = () => {
    const currentTopicIndex = topics.findIndex(
      (itm: { id: string }) => itm.id === p_topic
    );
    const step = Math.floor(100 / courseState.topicStates.length);
    setCourseState(p_course, {
      ...courseState,
      progress:
        courseState.step === courseState.topicStates.length - 1
          ? 100
          : currentTopicIndex * step === courseState.progress
          ? Number(courseState.progress) + step
          : courseState.progress,
      step:
        currentTopicIndex === courseState.step
          ? courseState.step + 1
          : courseState.step,
    });
    document?.querySelector('.course-body')?.scrollTo({
      top: 0,
      left: 0,
    });
    navigate(`/${language}/course/${p_course}/${currentTopic.next}`);
  };
  const toggleSide = () => {
    setSideCollapsed(!sideCollapsed);
  };
  if (
    !page?.landing?.courseSections?.some(
      (itm: any) => !itm.hide && itm.page === p_course
    ) &&
    p_course !== 'general-staff-a'
  ) {
    // eslint-disable-next-line no-restricted-globals
    // location.href = '/';
    console.log(p_course, 'p_course');
    return <div className="pagenotfound">404 Page Not found</div>;
  }
  return (
    <PageLayout pageName="course-page" pageClass={p_course}>
      <div
        className={`course-left-side ${sideCollapsed ? 'side-collapsed' : ''}`}
      >
        <MenuOutlined
          className="mobile-view toggle-menu-icon"
          onClick={toggleSide}
        />
        <Button
          className={`side-collapse-button ${
            sideCollapsed ? 'side-collapsed' : ''
          }`}
          type="text"
          onClick={toggleSide}
        >
          {sideCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </Button>
        <CourseOverview
          progress={progress}
          steps={steps}
          courseName={courseTitle}
          topicName={currentTopic.name}
          currentStep={currentStep}
        />
        <Paragraphs key={p_topic} paragraphs={paragraphs} />
      </div>
      <div className={`course-body ${sideCollapsed ? 'side-collapsed' : ''}`}>
        {p_course === 'general-staff-a' && (
          <GeneralStaff topicName={p_topic} topicSettings={topics} />
        )}
        {p_course === 'senior-manager' && (
          <SeniorManager topicName={p_topic} topicSettings={topics} />
        )}
        {p_course === 'finance' && (
          <Finance topicName={p_topic} topicSettings={topics} />
        )}
        {p_course === 'hr' && <HR topicName={p_topic} topicSettings={topics} />}
        {p_course === 'market' && (
          <Market topicName={p_topic} topicSettings={topics} />
        )}
        {p_course === 'customer' && (
          <Customer topicName={p_topic} topicSettings={topics} />
        )}
        {p_course === 'it' && <IT topicName={p_topic} topicSettings={topics} />}
        {p_course === 'ngo' && (
          <NGO topicName={p_topic} topicSettings={topics} />
        )}
        {p_course === 'E-commerce' && (
          <ECommerce topicName={p_topic} topicSettings={topics} />
        )}
        {p_course === 'startup' && (
          <Startup topicName={p_topic} topicSettings={topics} />
        )}
        {p_course === 'fsi' && (
          <FSI topicName={p_topic} topicSettings={topics} />
        )}
        {p_course === 'student' && (
          <Student topicName={p_topic} topicSettings={topics} />
        )}
        {p_course === 'cybersecurity2024' && (
          <General2024 topicName={p_topic} topicSettings={topics} />
        )}
        {nextTopic &&
          !currentParagraphState?.some((itm) => itm.state !== 'completed') && (
            <Button
              className="next-topic-button"
              type="text"
              key={nextTopic.title}
              onClick={gotoNextTopic}
            >
              <div>{nextLabel}</div>
              <div>{nextTopic.title}</div>
              <img src={NextTopicIcon} alt="" />
            </Button>
          )}
      </div>
    </PageLayout>
  );
};

export default Course;
